const { get } = require('lodash');
const { isValidComponent, isValidSection, isValidFunnel } = require('./validators');

const DEFAULT_RESPONSE = {};

/**
 * This class handles the structure & validation of go-p13n requests
 */
class StructuredApiResponse {
    constructor(data) {
        this.data = data;
    }

    byFunnel(isLazy) {
        if (!isValidFunnel(this.data, isLazy)) {
            return DEFAULT_RESPONSE;
        }

        return this.data;
    }

    bySection(sectionName, isLazy) {
        const section = get(this.data, sectionName, []);

        if (!isValidSection(section, isLazy)) {
            return DEFAULT_RESPONSE;
        }

        return {
            sections: this.data,
        };
    }

    byComponent(sectionName) {
        if (!isValidComponent(this.data)) {
            return DEFAULT_RESPONSE;
        }

        return {
            sections: {
                [sectionName]: [this.data],
            },
        };
    }
}

StructuredApiResponse.DEFAULT_RESPONSE = DEFAULT_RESPONSE;
module.exports = StructuredApiResponse;
